const hRouter = [
    {
        path: "/",
        meta: {title: "首页"},
        redirect: "/home",
        hidden: true,
        component: () => import("@/views/Layout"),
        children: [
            {
                path: "/accountList",
                name: "账号管理",
                meta: {
                    title: "账号管理"
                },
                component: function () {
                    return import("../views/accountmanagement/AccountList.vue");
                },
            },
            {
                path: "/role",
                name: "角色管理",
                meta: {
                    title: "角色管理"
                },
                component: function () {
                    return import("../views/role/index.vue");
                },
            },
            {
                path: "/equipmentmanagement",
                name: "设备管理",
                meta: {
                    title: "设备管理"
                },
                component: function () {
                    return import("../views/equipmentmanagement/EquipmentManagement.vue");
                },
            },
            {
                path: "/carmanagement",
                name: "车辆管理",
                meta: {
                    title: "车辆管理"
                },
                component: function () {
                    return import("../views/equipmentmanagement/CarManagement.vue");
                },
            },
            {
                path: '/workcamera',
                name: "记录仪",
                meta: {
                    title: "记录仪"
                },
                component: () =>
                    import('@/views/equipmentmanagement/WorkCameraManagement.vue'),
            },

            {
                path: '/pipenetmanagement',
                name: "管网管理",
                meta: {
                    title: "管网管理"
                },
                component: () =>
                    import('@/views/pipelinemanagement/PipeNetManagement.vue'),
            },
            {
                path: '/manholecover',
                name: "二维码管理（智能井盖）",
                meta: {
                    title: "二维码管理（智能井盖）"
                },
                component: () =>
                    import('@/views/pipelinemanagement/ManholeCoverQRCode.vue'),
            },
            {
                path: '/manholecover',
                name: "二维码管理（智能井盖）",
                meta: {
                    title: "二维码管理（智能井盖）"
                },
                component: () =>
                    import('@/views/pipelinemanagement/ManholeCoverQRCode.vue'),
            },
            {
                path: '/pipenet',
                name: "管网管理",
                meta: {
                    title: "管网管理"
                },
                component: () =>
                    import('@/views/pipelinemanagement/PipeNet.vue'),
            },
            {
                path: '/drainagepipe',
                name: "管道管理",
                meta: {
                    title: "管道管理"
                },
                component: () =>
                    import('@/views/pipelinemanagement/DrainagePipe.vue'),
            },
            {
                path: '/well',
                name: "管井管理",
                meta: {
                    title: "管井管理"
                },
                component: () =>
                    import('@/views/pipelinemanagement/Well.vue'),
            },
            {
                path: '/tenantManagement',
                name: "租户管理",
                meta: {
                    title: "租户管理"
                },
                component: () =>
                    import('@/views/tenant/TenantManagement.vue'),
            }

        ],
    },
];


export default hRouter;
